<template>
  <section class="result">
    <Header />
    <loading :active.sync="isLoading"
             :can-cancel="false"
             color="#E30713"
             :height = 145
             :width = 145
             :opacity = 1
             backgroundColor="#eeeeee"
             :z-index = 3
             :is-full-page="fullPage"
             ></loading>
    <div class="container">
      <div class="row">
        <div class="minor__title" @click="savePdfAll()">Результаты расчета</div>
        <div class="result__pane">
          <div class="result__pane-info">
            <div class="result__pane-info--title">{{ sectorsCount }}</div>
            <div class="result__pane-info--subtitle">
              <span class="md">{{ word }}</span>
              <span class="xs">Всего участков</span>
            </div>
          </div>
          <div class="result__pane-info">
            <div class="result__pane-info--title">{{ result.square }} м²</div>
            <div class="result__pane-info--subtitle">Площадь всех<br> участков</div>
          </div>
          <div class="result__pane-info" v-if="result.hasOwnProperty('count')">
            <div class="result__pane-info--title">{{ result.count }} шт. / м²</div>
            <div class="result__pane-info--subtitle">
              Среднее кол-во<br> крепежа на 1 м²<br> кровли
            </div>
          </div>
        </div>
        <div class="common__pane">
          <div class="common__title result__params-title">Параметры расчета</div>
          <div class="result__params">
            <div class="result__params-item">
              <div class="result__params-item--single">
                <div class="title">Ветровой район</div>
                <div class="value">{{ location.zone }}</div>
              </div>
              <div class="result__params-item--single">
                <div class="title">Нормативное значение<br> давления ветра W0</div>
                <div class="value">{{ location.pressure }} кПа</div>
              </div>
            </div>
            <div class="result__params-item">
              <div class="result__params-item--single">
                <div class="title">Тип местности</div>
                <div class="value">{{ location.type }}</div>
              </div>
              <div class="result__params-item--single">
                <div class="title">Коэффициент надежности<br>по ветровой нагрузке</div>
                <div class="value">{{ location.coefficient }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ResultNav />
    <ResultMaterialsComputation :resultMaterials="materials"/>
    <ResultFasteners :resultFasteners="fasteners"/>
    <ResultBallast />
    <Addons :resultAlbums="albums"/>
    <Plugins />
    <Prefooter @savePdf="savePdf()" @loadingStart="loadingStart()" @loadingEnd="loadingEnd()"/>
    <Footer />
  </section>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState, mapMutations, mapActions } from 'vuex';
import axios from 'axios';
import { saveAs } from 'file-saver';
import { isSafari } from '@/utils/utils';
import ResultNav from '@/components/Result/ResultNav.vue';
import ResultMaterialsComputation from '@/components/Result/ResultMaterialsComputation.vue';
import ResultFasteners from '@/components/Result/ResultFasteners.vue';
import ResultBallast from '@/components/Result/ResultBallast.vue';
import Header from '@/components/Header.vue';
import Addons from '@/components/Addons.vue';
import Plugins from '@/components/Plugins.vue';
import Prefooter from '@/components/Prefooter.vue';
import Footer from '@/components/Footer.vue';

export default {
  data() {
    return {
      materials: [],
      albums: [],
      fasteners: [],
      fullPage: true,
      isLoading: false,
    };
  },
  components: {
    ResultNav,
    ResultMaterialsComputation,
    ResultFasteners,
    ResultBallast,
    Header,
    Addons,
    Plugins,
    Prefooter,
    Footer,
    Loading,
  },
  methods: {
    ...mapMutations({
      UPDATE_RESULT: 'UPDATE_RESULT',
      UPDATE_STATE_OBJECT: 'UPDATE_STATE_OBJECT',
    }),
    ...mapActions({
      fetchData: 'fetchData',
    }),
    savePdf() {
      this.isLoading = true;
      const baseUrl = (process.env.NODE_ENV === 'development') ? process.env.VUE_APP_API_URL : `${window.location.origin}/`;
      const string = new URLSearchParams();
      string.append('type', 'pdf_total');
      const postData = {};
      const postDataHeader = {};
      const postDataFront = {};
      postDataFront.userInfo = this.userInfo;
      postDataFront.year = new Date().getFullYear();
      postDataHeader.square = this.result.square;
      // eslint-disable-next-line no-prototype-builtins
      if (this.result.hasOwnProperty('count')) {
        postDataHeader.count = this.result.count;
      }
      postDataHeader.link = this.userInfo.link;
      postDataHeader.zone = this.location.zone;
      postDataHeader.type = this.location.type;
      postDataHeader.pressure = this.location.pressure;
      postDataHeader.coefficient = this.location.coefficient;
      postData.header = postDataHeader;
      postData.firstPage = postDataFront;
      postData.materials = this.materials;
      postData.albums = this.albums;
      postData.fasteners = this.fasteners;
      // eslint-disable-next-line no-prototype-builtins
      if (this.result.hasOwnProperty('ballast')) {
        postData.ballast = this.result.ballast;
      }
      if (process.env.NODE_ENV === 'development') {
        console.log(postData);
      }
      string.append('data', JSON.stringify(postData));
      axios.post(`${baseUrl}service_api/pdf`, string, {
        responseType: 'blob', // Force to receive data in a Blob Format
      })
        .then((response) => {
          // console.log(response);
          // Create a Blob from the PDF Stream
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' },
          );
          // Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          this.isLoading = false;
          if (this.isSafari) {
            const fileName = 'Краткий расчет.pdf';
            saveAs(file, fileName);
          } else {
            window.open(fileURL);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadingStart() {
      this.isLoading = true;
    },
    loadingEnd() {
      this.isLoading = false;
    },
  },
  async mounted() {
    const baseUrl = (process.env.NODE_ENV === 'development') ? process.env.VUE_APP_API_URL : `${window.location.origin}/`;
    const hash = new URLSearchParams();
    const urlQuery = this.$route.query.object;
    hash.append('data', urlQuery);
    if (typeof (urlQuery) !== 'undefined') {
      this.isLoading = true;
      await this.fetchData();
      axios.post(`${baseUrl}service_api/results_get`, hash)
        .then((response) => {
          // console.log(JSON.parse(response.data.result));
          this.materials = JSON.parse(response.data.result).total.materials;
          this.albums = JSON.parse(response.data.result).total.albums;
          this.fasteners = JSON.parse(response.data.result).total.fasteners;
          this.UPDATE_RESULT(JSON.parse(response.data.result));
          this.UPDATE_STATE_OBJECT({
            object: 'location',
            val: JSON.parse(response.data.location),
          });
          this.UPDATE_STATE_OBJECT({
            object: 'sectors',
            val: JSON.parse(response.data.sectors),
          });
          this.$router.push('/result');
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$router.push('/404');
        });
    } else {
      this.isLoading = true;
      if (this.location.zone === '') {
        this.$router.push('/');
        this.isLoading = false;
      } else {
        const postData = new URLSearchParams();
        postData.append('sectors', JSON.stringify(this.sectors));
        postData.append('location', JSON.stringify(this.location));
        if (process.env.NODE_ENV === 'development') {
          console.log(postData);
        }
        axios.post(`${baseUrl}service_api/calculate_total`, postData)
          .then((response) => {
            if (process.env.NODE_ENV === 'development') {
              console.log(response.data.total);
            }
            this.UPDATE_RESULT(response.data);
            this.materials = response.data.total.materials;
            this.albums = response.data.total.albums;
            this.fasteners = response.data.total.fasteners;
            this.isLoading = false;
          });
      }
    }
  },
  computed: {
    ...mapState({
      result: state => state.result.total,
      resultSectors: state => state.result.sectors,
      insulationMaterials: state => state.insulationMaterials,
      allMaterials: state => state.materials,
      sectors: state => state.sectors,
      location: state => state.location,
      userInfo: state => state.userInfo,
    }),
    isSafari() {
      return isSafari();
    },
    word() {
      const cases = [2, 0, 1, 1, 1, 2];
      const words = ['участок', 'участка', 'участков'];
      return words[(this.sectorsCount % 100 > 4
        && this.sectorsCount % 100 < 20) ? 2
        : cases[(this.sectorsCount % 10 < 5)
          ? this.sectorsCount % 10 : 5]];
    },
    sectorsCount() {
      // return this.allSlopes.length;
      let total = 0;
      for (let i = 0; i < this.sectors.length; i += 1) {
        total += this.sectors[i].sectorsCount;
      }
      return total;
    },
  },
};
</script>
<style lang="sass" scoped>
  .result
    &__pane
      background: #ffffff
      border-radius: rem(4)
      width: 100%
      display: grid
      +media((margin-bottom: (320: rem(16), 768: rem(34))))
      +media((padding: (320: rem(32) 0 rem(16), 768: rem(20) 0)))
      +media((grid-template-columns: (320: 1fr, 768: 5fr 7fr 12fr)))
      &-info
        color: $black
        text-align: left
        display: flex
        +media((align-items: (320: center, 768: flex-start)))
        +media((padding: (320: 0 rem(24) rem(16), 768: 0)))
        +media((flex-direction: (320: row, 768: column)))
        &:first-of-type
          +media((padding-left: (320: rem(24), 768: rem(30))))
        &--title
          font-weight: bold
          font-size: rem(36)
          +media((width: (320: 50%, 768: auto)))
          +media((order: (320: 2, 768: 1)))
          +media((padding-left: (480: rem(20), 768: 0)))
          +media((font-size: (320: rem(20), 360: rem(22), 960: rem(36))))
          +media((line-height: (320: rem(31), 360: rem(33), 960: rem(44))))
        &--subtitle
          font-style: normal
          font-weight: 500
          line-height: rem(18)
          +media((width: (320: 50%, 960: auto)))
          +media((order: (320: 1, 960: 2)))
          +media((font-size: (320: rem(12), 960: rem(14))))
          .md
            +media((display: (320: none, 768: inline-block)))
          .xs
            +media((display: (320: inline-block, 768: none)))
          br
            +media((display: (320: inline-block, 480: none)))
    &__params
      display: grid
      +media((grid-column-gap: (768: rem(20), 960: rem(80))))
      +media((grid-template-columns: (320: 1fr, 768: 1fr 1fr)))
      &-title
        +media((padding-bottom: (320: rem(24), 960: rem(34))))
      &-item
        text-align: left
        &--single
          display: grid
          font-style: normal
          font-weight: 500
          font-size: rem(14)
          line-height: rem(20)
          color: $black
          +media((grid-template-columns: (320: 8fr 4fr, 480: 1fr 1fr, 768: 7fr 3fr)))
          +media((font-size: (320: rem(13), 960: rem(14))))
          +media((line-height: (320: rem(19), 960: rem(20))))
          +media((padding-bottom: (320: rem(16), 960: rem(20))))
          &:last-of-type
            +media((padding-bottom: (320: rem(16), 960: rem(10))))
          .value
            font-weight: bold
            +media((padding-left: (480: rem(20), 768: 0)))
          .title, .value
            display: flex
            flex-direction: row
            align-items: center
        &:last-of-type
          .result__params-item--single
            &:last-of-type
              +media((padding-bottom: (320: 0, 960: rem(10))))
</style>
